import type { TBlueObj } from "@app/types/insider";
export type TUIFiscalBook = {
  selectedBookId: number; //FCT_FF
};

export const uiFiscalBooks: TBlueObj<TUIFiscalBook> = {
  name: "uiFiscalBooks",
  initialState: {
    selectedBookId: 0,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
